import { PAGE_SIZE } from '@/constants'
import { buildQuery } from '@/utils/helpers'
import fetcher, { fetchWithToken } from '../fetcher'

export const ORDERS_HISTORY = `
query inforCustomer(
    $sort: CustomerOrderSortInput
    $currentPage: Int
    $pageSize: Int
    $filter: CustomerOrdersFilterInput
    $scope: ScopeTypeEnum
    $statusFilter: CustomerOrderStatusFilter
  ) {
    customer {
      orders(
        filter: $filter
        sort: $sort
        currentPage: $currentPage
        pageSize: $pageSize 
        scope:$scope
        status_filter: $statusFilter
      ) {
        total_count
        page_info {
          current_page
          page_size
          total_pages
        }
        items {
          order_date
          id
          number
          point_info {
            cashback_status
            order_received_at
            shipping_amount
            point_cashback
            submit_status
          }
          comments {
            ...SalesCommentItemFields
          }
          invoices {
            id
            number
            comments {
              timestamp
              ...SalesCommentItemFields
            }
            items {
              id
              product_sale_price {
                ...MoneyFields
              }
              discounts {
                amount {
                  ...MoneyFields
                }
                ...DiscountFields
              }
              product_name
              product_sku
              quantity_invoiced
            }
          }
          items {
            id
            product_image
            product_name
            quantity_ordered
            product_sale_price {
              ...MoneyFields
            }
          }
          carrier
          status
          total {
            grand_total {
              ...MoneyFields
            }
            base_grand_total {
              ...MoneyFields
            }
            total_shipping {
              ...MoneyFields
            }
            discounts {
              amount {
                ...MoneyFields
              }
              ...DiscountFields
            }
            subtotal {
              ...MoneyFields
            }
          }
          shipping_method
        }
      }
    } 
  }

  fragment MoneyFields on Money {
    value
    currency
  }

  fragment SalesCommentItemFields on SalesCommentItem {
    message
  }

  fragment DiscountFields on Discount {
    label
  }
`

export const GET_TRACKING_ORDER = `

query trackingOrder($orderId: String!,$emailOrPhone: String!) { 
  trackingOrder (orderId: $orderId,emailOrPhone:$emailOrPhone) { 
    order{
    shipping_method 
    carrier 
    comments { 
      ...SalesCommentItemFields 
    } 
    status 
    state
    number 
    customer_email
    order_date 
    timeline{
      label
      status
      date  
    }
    point_info {
      cashback_status
      order_received_at
      shipping_amount
      point_cashback
    }
    shipping_address { 
      city 
      company 
      country_code 
      fax 
      firstname 
      lastname 
      postcode 
      region_id 
      region 
      street 
      telephone 
      district 
      ward
      customer_notes
    } 
    billing_address { 
      city  
      company 
      country_code  
      fax  
      firstname  
      lastname  
      postcode  
      region_id  
      region  
      street  
      telephone  
      district  
      ward
      customer_notes
    } 
    shipments { 
      comments { 
        ...SalesCommentItemFields 
      } 
      number 
      tracking { 
        carrier 
        number 
        title 
      } 
    } 
    discount_description {
      amount {
        currency
        value
      }
      discount_amount
      label
      rule_id
      type
    }
    total { 
      base_grand_total { 
        ...MoneyFields 
      } 
      discounts { 
     
        amount { 
          ...MoneyFields 
        } 
        ...DiscountFields 
      } 
        
      grand_total { 
        ...MoneyFields 
      } 
      shipping_handling { 
        amount_excluding_tax { 
          ...MoneyFields 
        } 
        amount_including_tax { 
          ...MoneyFields 
        } 
        discounts { 
          amount { 
            ...MoneyFields 
          } 
        } 
      } 
      subtotal { 
        ...MoneyFields 
      } 
      total_shipping { 
        ...MoneyFields 
      } 
    } 
    products { 
      discounts { 
        amount { 
          ...MoneyFields 
        } 
        ...DiscountFields 
      } 
      product_image 
      product_name 
      product_sale_price { 
        ...MoneyFields 
      } 
      product_sku 
      status 
      product_url_key 
      quantity_ordered 
      selected_options { 
        label 
        value 
      } 
    } 
     timeline{
      label
      status
      date  
    }
  } }
}fragment SalesCommentItemFields on SalesCommentItem { 
  message 
  timestamp 
} 
fragment MoneyFields on Money { 
  currency 
  value 
} 
fragment DiscountFields on Discount { 
  label 
}


`

export const GET_ORDER_HISTORY_DETAIL = `
query getOrderDetailCustomer($orderId: String!) { 
  orderDetailCustomer(orderId: $orderId) { 
    shipping_method 
    carrier 
    comments { 
      ...SalesCommentItemFields 
    } 
    status 
    state
    number 
    customer_email
    order_date 
    timeline{
      label
      status
      date  
    }
    point_info {
      cashback_status
      order_received_at
      shipping_amount
      point_cashback
    }
    shipping_address { 
      city 
      company 
      country_code 
      fax 
      firstname 
      lastname 
      postcode 
      region_id 
      region 
      street 
      telephone 
      district 
      ward
      customer_notes
    } 
    billing_address { 
      city  
      company 
      country_code  
      fax  
      firstname  
      lastname  
      postcode  
      region_id  
      region  
      street  
      telephone  
      district  
      ward
      customer_notes
    } 
    shipments { 
      comments { 
        ...SalesCommentItemFields 
      } 
      number 
      tracking { 
        carrier 
        number 
        title 
      } 
    } 
    discount_description {
      amount {
        currency
        value
      }
      discount_amount
      label
      rule_id
      type
    }
    total { 
      base_grand_total { 
        ...MoneyFields 
      } 
      discounts { 
     
        amount { 
          ...MoneyFields 
        } 
        ...DiscountFields 
      } 
        
      grand_total { 
        ...MoneyFields 
      } 
      shipping_handling { 
        amount_excluding_tax { 
          ...MoneyFields 
        } 
        amount_including_tax { 
          ...MoneyFields 
        } 
        discounts { 
          amount { 
            ...MoneyFields 
          } 
        } 
      } 
      subtotal { 
        ...MoneyFields 
      } 
      total_shipping { 
        ...MoneyFields 
      } 
    } 
    items { 
      discounts { 
        amount { 
          ...MoneyFields 
        } 
        ...DiscountFields 
      } 
      product_image 
      product_name 
      product_sale_price { 
        ...MoneyFields 
      } 
      product_sku 
      status 
      product_url_key 
      quantity_ordered 
      selected_options { 
        label 
        value 
      } 
    } 
  } 
}fragment SalesCommentItemFields on SalesCommentItem { 
  message 
  timestamp 
} 
fragment MoneyFields on Money { 
  currency 
  value 
} 
fragment DiscountFields on Discount { 
  label 
}
`

export const GET_CUSTOMER_ORDER_COUNTS = `
query CustomerOrderCounts {
  customerOrderCounts {
    closed
    complete
    pending_processing
    shipping
    total_orders
  }
}
`
interface OrdersHistoryProps {
  currentPage?: number
  pageSize?: number
  filter?: {
    number: {
      match: string
    }
  }
  sort?: {
    sort_field: 'CREATED_AT' | string
    sort_direction: 'DESC' | 'ASC'
  }
  scope?: 'GLOBAL'
  status?: string
}

export async function getCustomerOrderCounts() {
  try {
    const res = await fetchWithToken(
      {
        query: GET_CUSTOMER_ORDER_COUNTS,
      },
      {
        next: { tags: ['customer-order-counts'] },
        cache: 'force-cache',
      }
    ).then((r) => r?.payload)
    const data = res?.data?.customerOrderCounts
    if (!data) return { data: null, status: 'error', message: res?.errors?.[0]?.message }
    return { data: data, status: 'success', message: 'Get order counts successfully' }
  } catch (err) {
    console.log('error in order counts', err)
    return null
  }
}

export async function getOrdersHistory(params?: OrdersHistoryProps) {
  let variables: any = {
    currentPage: params?.currentPage ?? 1,
    pageSize: params?.pageSize ?? 10,
    sort: {
      sort_field: params?.sort?.sort_field ?? 'CREATED_AT', // "NUMBER"
      sort_direction: params?.sort?.sort_direction ?? 'DESC', // "ASC"
    },
    scope: params?.scope ?? 'GLOBAL',
  }

  if (params?.status) {
    variables = {
      ...variables,
      statusFilter: params.status,
    }
  }

  try {
    const res = await fetchWithToken(
      {
        query: ORDERS_HISTORY,
        variables: variables,
      },
      {
        next: { tags: ['orders'] },
        cache: 'force-cache',
      }
    ).then((r) => r?.payload)
    const data: OrderType = res?.data?.customer?.orders
    if (!data) return { data: null, status: 'error', message: res?.errors?.[0]?.message }
    return { data: data, status: 'success', message: 'Get order history successfully' }
  } catch (err) {
    console.log('error in order history', err)
    return null
  }
}

export async function getTrackingOrder(data?: { orderId: string; emailOrPhone: string }) {
  try {
    const res = await fetcher
      .get(buildQuery(GET_TRACKING_ORDER, { orderId: data?.orderId, emailOrPhone: data?.emailOrPhone }), {
        next: { tags: ['tracking-order', data?.orderId ?? '', data?.emailOrPhone ?? ''] },
      })
      .then((r) => r?.payload)
    const response = res?.data?.trackingOrder?.order
    if (!response) return { status: 'error', message: res?.errors?.[0]?.message }
    return { status: 'success', data: response, message: 'Get order successfully' }
  } catch (err) {
    console.log('error in tracking-order', err)
    return { status: 'error', message: (err as Error)?.message || 'Có lỗi xảy ra, vui lòng thử lại!' }
  }
}

export async function getOrderHistoryDetail(params: string) {
  const res = await fetchWithToken(
    {
      query: GET_ORDER_HISTORY_DETAIL,
      variables: {
        orderId: params,
      },
    },
    {
      next: { tags: ['orders-detail', params], revalidate: 120 },
      cache: 'force-cache',
    }
  ).then((r) => r?.payload)
  const data: IItemsOrderHistory = res?.data?.orderDetailCustomer
  if (!data) return { data: null, status: 'error', message: res?.errors?.[0]?.message }
  return { data: data, status: 'success', message: 'Get order history successfully' }
}
